import { DataLocationStorageType, DataLocationFileFormat } from "../views/DataSourceCreate/models/DataSourceDataCommon.js";
const CosmosDataLocation = {
  DataPath: "",
  VC: "",
  Cluster: ""
};
const AzureBlobLocation = {
  DataPath: "",
  StorageAccount: "",
  Container: ""
};
const ADLSGen2Location = {
  DataPath: "",
  StorageAccount: "",
  Container: "",
  Url: "",
  SecretName: ""
};
const MTLocation = [
  {
    Region: "",
    DataPath: "",
    EndPoint: "",
    required: {
      DataPath: "Required",
      EndPoint: "Required"
    }
  }
];
const DataLocationDataType = {
  CosmosCosmosView: `${DataLocationStorageType.Cosmos}-${DataLocationFileFormat.CosmosView}`,
  AzureBlobParquet: `${DataLocationStorageType.AzureBlob}-${DataLocationFileFormat.Parquet}`,
  ADLSGen2Parquet: `${DataLocationStorageType.ADLSGen2}-${DataLocationFileFormat.Parquet}`,
  MTParquet: `${DataLocationStorageType.MT}-${DataLocationFileFormat.Parquet}`,
  ADLSGen2CosmosView: `${DataLocationStorageType.ADLSGen2CosmosView}-${DataLocationFileFormat.CosmosView}`
};
export {
  ADLSGen2Location,
  AzureBlobLocation,
  CosmosDataLocation,
  DataLocationDataType,
  MTLocation
};
//# sourceMappingURL=DataSource.DataLocation.constants.js.map
